import styled, {keyframes} from 'styled-components';
import IconButton from '../../../atoms/UI/buttons/IconButton';
import {basicColor, device} from '../../../../styles/template';

export const BarWrap = styled.div`
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  
    position: fixed;
    width: 100%;
    padding: 3rem;
    bottom: 0;
    left: 0;
    z-index: 1000;
    background-image: linear-gradient(to top,  ${props => props.cssBack} 25%, 85%, rgba(0, 0, 0, 0));
    
    & .colorFill {
        fill: ${basicColor.white};
    }

    & .colorStroke {
        stroke: ${basicColor.white};
    }

    @media ${device.mobileM} {
        grid-template-columns: 1fr auto;
    }
`;

const LikeSpin =  keyframes`
    0% {
        transform: rotate(0turn) scale(1);
    }
    
    50% {
        transform: rotate(1turn) scale(1.3);
    }
    
    100% {
        transform: scale(1);
    }
`

const DislikeBounce =  keyframes`
    from {
        transform: translateY(0px);
    }
    to {
        transform: translateY(-10px);
    }
`

export const SquareIcon = styled(IconButton)`
  width: 100%;
  padding: 0;
  height: 6rem;
  min-width: 6rem;

  &.animate {
    &.like svg {
      animation: ${LikeSpin} 600ms;
    }
    &.dislike svg {
      animation: ${DislikeBounce} 600ms;
      animation-duration: 300ms;
      animation-direction: alternate;
      animation-iteration-count: 2;
      animation-timing-function: cubic-bezier(.2, .65, .6, 1);
    }
  }
  
  &.dislike .colorFill {
    fill: ${basicColor.red};
  }

  &.dislike .colorStroke {
    stroke: ${basicColor.red};
  }

  &.like .colorFill {
    fill: ${basicColor.secondary};
  }

  &.like .colorStroke {
    stroke: ${basicColor.secondary};
  }
`

export const ArrowButton = styled(IconButton)`
  height: 6rem;
  max-width: none;
  width: 100%;
  
  &.accept {
    background: ${basicColor.secondaryDark};
  }

  @media ${device.tablet} {
    max-width: 20rem;
  }
`

export const LeftBar = styled.div`
    display: flex;
    gap: 1rem;
`;

export const RightBar = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
`;



